import { Inject } from '@odinjs/odin';
import { BarcodeData, BarcodeReaderType, BarcodeService, PanelAPI, ToastService } from '@philips-internal/oswald-ui-components';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ReadEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService, MessageService,  } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import { Endpoint } from '../../../../constants/endpoints';
import { ApplicationRoute } from '../../../../constants/routes';
import { FoundationUtils } from '../../../../utils/foundation-utils';
import { EC_9130Parameters } from '../../../../utils/parameters';
import BaseController from '../../../BaseController';

@Controller({ component: 'send-prescription-context-layout', fragment: 'send-prescription-context' })
class SendPrescriptionContextController extends BaseController {

  @Inject('with-contextualbar-panel')
  withContextualBarPanelApi!: PanelAPI;

  @Inject('no-contextualbar-panel')
  noContextualBarPanelApi!: PanelAPI;

  @OnMount({ target: 'send-prescription-context-layout' })
  onMount(): void {
    const paramUseLaboratorySampleStandard = FoundationUtils.findModuleParam('EXAM_COLLECT#9130', EC_9130Parameters.USE_LABORATORY_SAMPLE_STANDARD);

    if('S' === paramUseLaboratorySampleStandard) {
      this.withContextualBarPanelApi.setVisible(false);
      this.noContextualBarPanelApi.setVisible(true);
    }
  }

  @OnClick({ target: 'barcode-prescription'})
  revertReadSuccess():void {
    this.openRevertBarcode();
  }

  openRevertBarcode(): void {
    BarcodeService.open({
      data: [],
      defaultReadType: BarcodeReaderType.CAMERA,
      hasDescription: false,
      id: 'revert-prescription-barcode',
      infraredInputSubmitExpression: 'tws.barcode.manual-submit',
      onReadSuccess: (event: ReadEvent<BarcodeData>) => {
        this.revertPrescription(event);
      },
      requireDescription: false,
      requireReason: false,
      supportCamera: true,
      supportInfrared: true,
    });
  }

  showRevertPrescriptionToast(message: string, level: ToastLevel): void {
    const toastId = message;
    ToastService.close(toastId);
    ToastService.open({
      dismissible: true,
      id: toastId,
      level: level,
      message: MessageService.translate(message),
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    });
  }

  revertPrescription(event: ReadEvent<BarcodeData>): void {
    const prescription = this.historyService.getCurrentRouteParams().prescription;

    const queryParams = {
      allowRevert: FoundationUtils.findModuleParam('SEND_EXAM_SAMPLE#9131', 'REVERT_STATUS_ALLOWED#3'),
      container: prescription === 'undefined' ? 'null' : prescription,
      prescription: event.item.value.trim(),
    }

    HttpService.get(Endpoint.REVERT_PRESCRIPTION, queryParams).then(() => {
      this.showRevertPrescriptionToast('tws.pending-exam-collection.exam-collection-success', ToastLevel.SUCCESS);
      applicationContext.redirect(ApplicationRoute.SEND_EXAM_SAMPLE + '/send-container');
    }).catch(() => this.showRevertPrescriptionToast('tws.error-generic', ToastLevel.ERROR)
    );
  }
}

export default SendPrescriptionContextController;
